if (!customElements.get('discount-form')) {
    customElements.define('discount-form', class DiscountForm extends HTMLElement {
        constructor() {
            super();
            let _this = this;
            setTimeout(()=>{
               _this.init();
            }, 500);
        }

        init(){
            let _this = this;
            let button = this.querySelector('#discount-btn');
            button.addEventListener('click', (e)=>{
                e.preventDefault();
                let discount_code = _this.querySelector('#discount_code');
                let code = trim(discount_code.value);
                if(code != ''){
                    _this.applyDiscountToCart(discount_code, button);
                }
            });
        }

        applyDiscountToCart(discountCode, button) {
            // Build the URL for the API endpoint
            const url = '/discount/' + discountCode.value + '/apply';
          
            // Create a new FormData object to hold the discount code
            // const formData = new FormData();
            // formData.append('discount', discountCode.value);
            button.classList.add('loading');
          
            // Send the request to the API using the Fetch API
            fetch(url, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({})
            })
            .then(response => response.json())
            .then(data => {
            //   Handle the response data as needed
                button.classList.remove('loading');
            //   console.log(data);
            })
            .catch(error => {
                button.classList.remove('loading');
              // Handle any errors that occur
            //   console.error(error);
            });
          }
          

    });

}